import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

// Ao clicar, previne a acao default e exibe um alerta swal a partir de
// data-attributes. Usado nas guardas de "enviar nova senha" dos cartoes.
export default class extends Controller {
  static values = { html: String, icon: { type: String, default: "warning" } }

  show(event) {
    event.preventDefault()
    Swal.fire({ html: this.htmlValue, icon: this.iconValue })
  }
}
